import React from 'react';
import PropTypes from 'prop-types';
import { SortableContainer } from 'react-sortable-hoc';
import PageListItem from '../PageListItem/PageListItem';
import './PageList.styles.less';

const PageList = SortableContainer(({ registry, pages, orderedIds, onToggle, hasRegistry, registryPublished, onRegistryPublish, handleOpenRegistryModal }) => (
  <ul className="mpr-page-list">
    {orderedIds.map((pageId, idx) => (
      <PageListItem
        key={idx}
        index={idx}
        onToggle={() => onToggle(pageId, pages[pageId])}
        page={pages[pageId]}
        hasRegistry={hasRegistry}
        registry={registry}
        onRegistryPublish={onRegistryPublish}
        registryPublished={registryPublished}
        handleOpenRegistryModal={handleOpenRegistryModal}
      />
    ))}
  </ul>
));

PageList.propTypes = {
  pages: PropTypes.shape({}),
  orderedIds: PropTypes.arrayOf(PropTypes.number),
  onToggle: PropTypes.func,
  onSortEnd: PropTypes.func,
  onRegistryPublish: PropTypes.func,
  hasRegistry: PropTypes.bool,
  registryPublished: PropTypes.bool,
  registry: PropTypes.shape({}),
  handleOpenRegistryModal: PropTypes.func.isRequired
};

export default PageList;



// WEBPACK FOOTER //
// ./src/components/manage/website/ManagePagesRedesign/Pages/PageList/PageList.jsx